export const UserActionTypes = {
  SET_LOGGED_IN_STATUS: "SET_LOGGED_IN_STATUS",
  SET_USER_DATA: "SET_USER_DATA",
  SET_AUTH_DATA: "SET_AUTH_DATA",
  SET_IDLE_MODAL: "SET_IDLE_MODAL",
  SET_USER_DETAILS: "SET_USER_DETAILS",
  SET_FIRST_LOGIN: "SET_FIRST_LOGIN",
  SET_IP_ADDRESS: "SET_IP_ADDRESS",
  SET_TOUR: "SET_TOUR",
  RESET_STATE: "RESET_STATE",
};
